import { BUNDLE } from 'apps/auth/constants/EntryPoint';
import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import GAExchangePage from 'apps/auth/pages/ga/GAExchangePage';

const gaExchange = [
    {
        path: '/auth/ga/pocket/:pocketId/exchange',
        component: GAExchangePage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
];

export default gaExchange;
